const hasDuplicate = (recip) => {
  return !!recip && !!recip.duplicates && recip.duplicates.length > 0;
};

export default hasDuplicate;
